module.exports = __webpack_public_path__ + "media/src/img/payment/o-nas-1-880b328280144501f320713854eefa11.jpg";